class TopUpPaymentCtrl {

}

export { TopUpPaymentCtrl }


// WEBPACK FOOTER //
// ./app/topup/payment_ctrl.ts